export default "__VITE_ASSET__7b02015c__"